import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Wrench, Code, Puzzle, Zap } from 'lucide-react'

const OdooCustomization = () => {
  const features = [
    {
      icon: <Wrench className="w-6 h-6" data-component-path="client/src/pages/services/OdooCustomization.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/OdooCustomization.jsx:7:12" />,
      title: 'Custom Modules',
      description: 'Bespoke features built for your workflow'
    },
    {
      icon: <Code className="w-6 h-6" data-component-path="client/src/pages/services/OdooCustomization.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/OdooCustomization.jsx:13:12" />,
      title: 'API Integration',
      description: 'Connect Odoo with external systems'
    },
    {
      icon: <Puzzle className="w-6 h-6" data-component-path="client/src/pages/services/OdooCustomization.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/OdooCustomization.jsx:19:12" />,
      title: 'Workflow Automation',
      description: 'Streamline processes with custom logic'
    },
    {
      icon: <Zap className="w-6 h-6" data-component-path="client/src/pages/services/OdooCustomization.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/OdooCustomization.jsx:25:12" />,
      title: 'Performance Tuning',
      description: 'Optimize Odoo for maximum efficiency'
    },
  ]

  return (
    <ServiceTemplate
      title="Odoo Customization"
      subtitle="Tailor Odoo to match your exact business requirements"
      description="Extend Odoo's capabilities with custom modules, integrations, and workflows designed specifically for your business. Our expert developers create solutions that seamlessly integrate with Odoo's core while adding the unique features you need."
      features={features}
      heroImage="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default OdooCustomization